import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import $ from "jquery";

function BootGate({ children }) {
  React.useLayoutEffect(() => {
    try {
      window.__reactMounted = true; // optional debug flag

      if (window.__bootErrorVisible) {
        return;
      }

      // unlock page scroll
      document.documentElement.classList.remove('app-booting');
      document.body.classList.remove('app-booting');

      const el = document.getElementById('initial-loader');
      if (el) {
        // start fade and then remove when transition completes
        el.classList.add('loader--hide');
        const remove = () => el.remove();
        // fallback in case transitionend is missed
        const t = setTimeout(remove, 150);
        el.addEventListener('transitionend', () => { clearTimeout(t); remove(); }, { once: true });
      }
    } catch (e) {
      console.error('BootGate error:', e);
      // In worst case, still remove the loader to avoid getting stuck.
      const el = document.getElementById('initial-loader');
      if (el) el.remove();
      document.documentElement.classList.remove('app-booting');
      document.body.classList.remove('app-booting');
    }
  }, []);
  return children;
}

$(document).ajaxError(function (event, xhr) {
  if (xhr?.status === 401) {
    localStorage.removeItem("apiUser");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");

    // Reload current page; App() will render <Login /> because token is gone/invalid
    window.location.reload();
    return;
  }

  if (xhr?.status === 0 || xhr?.status === 502 || xhr?.status === 503 || xhr?.status === 504) {
    if (typeof window.__showBootError === "function") {
      window.__showBootError();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BootGate>
      <App />
    </BootGate>
  </React.StrictMode>

    // <App />
);
